import { render } from "./MarkAttendance.vue?vue&type=template&id=1120c113&scoped=true"
import script from "./MarkAttendance.vue?vue&type=script&lang=js"
export * from "./MarkAttendance.vue?vue&type=script&lang=js"

import "./MarkAttendance.vue?vue&type=style&index=0&id=1120c113&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1120c113"]])

export default __exports__